import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

/**
 * Wraps the /re-evaluation/* and re-evaluation-related /evaluation/* endpoints.
 * Keeps the regular EvaluationService untouched so the two flows can evolve
 * independently as the BE plan rolls out.
 */
@Injectable({
  providedIn: 'root'
})
export class ReEvaluationService {

  key: string = 're-evaluation';

  constructor(public hs: HttpService, public gs: GlobalService) { }

  // -------- Student --------

  async request(value: any) {
    try {
      return await this.hs.post(`/evaluation/request-re-evaluation`, {}, value);
    } catch (error: any) {
      throw error;
    }
  }

  // Shared list endpoint — admin sees everything, students auto-scoped to self by BE.
  async get_list(filters: any) {
    try {
      return await this.hs.get(`/evaluation/get-re-evaluation-list`, filters);
    } catch (error: any) {
      throw error;
    }
  }

  // -------- Admin --------

  async assign_evaluators(assignments: { request_id: number; evaluator_id: number; head_evaluator_id?: number | null }[]) {
    try {
      return await this.hs.post(`/${this.key}/assign-evaluators`, {}, { assignments });
    } catch (error: any) {
      throw error;
    }
  }

  async auto_assign(request_ids: number[]) {
    try {
      return await this.hs.post(`/${this.key}/auto-assign`, {}, { request_ids });
    } catch (error: any) {
      throw error;
    }
  }

  // -------- Evaluator --------

  async start(value: { script_id: number }) {
    try {
      return await this.hs.post(`/${this.key}/add-${this.key}`, {}, value);
    } catch (error: any) {
      throw error;
    }
  }

  async get(evaluation_id: number) {
    try {
      return await this.hs.get(`/${this.key}/get-${this.key}?evaluation_id=` + evaluation_id, {});
    } catch (error: any) {
      throw error;
    }
  }

  async draft(value: any) {
    try {
      return await this.hs.post(`/${this.key}/save-as-draft`, {}, { is_draft: true, ...value });
    } catch (error: any) {
      throw error;
    }
  }

  async submit(value: any) {
    try {
      return await this.hs.post(`/${this.key}/update-${this.key}`, {}, value);
    } catch (error: any) {
      throw error;
    }
  }

  // -------- Head Evaluator --------

  async start_head(value: { script_id: number }) {
    try {
      return await this.hs.post(`/${this.key}/start-head-re-evaluation`, {}, value);
    } catch (error: any) {
      throw error;
    }
  }

  // -------- Payment (BillDesk) --------

  async initiate_payment(value: { script_id: number; reason: string }) {
    try {
      return await this.hs.post(`/payment/initiate-re-evaluation-payment`, {}, value);
    } catch (error: any) {
      throw error;
    }
  }

  async get_payment_status(request_id: string) {
    try {
      return await this.hs.get(`/payment/get-payment-status`, { request_id });
    } catch (error: any) {
      throw error;
    }
  }

  async retry_payment(request_id: string) {
    try {
      return await this.hs.post(`/payment/retry-re-evaluation-payment`, {}, { request_id });
    } catch (error: any) {
      throw error;
    }
  }
}
